;(function($) {

    var oScrollEnd = new jindo.m.ScrollEnd();

    $.fn.lazyImage = function(threshold, callback) {

        var $w = $(window),
            th = threshold || 0,
            retina = window.devicePixelRatio > 1,
            attrib = retina ? "data-src-retina" : "data-src",
            images = this,
            loaded;

        this.one("lazyImage", function() {
            var source = this.getAttribute(attrib);
            source = source || this.getAttribute("data-src");

            if (source) {
                this.setAttribute("src", source);
                if (typeof callback === "function") {
                    callback.call(this);
                }
            }
        });

        function lazyImage() {
            var inview = images.filter(function() {
                var $e = $(this);

                if ($e.is(":hidden")) {
                    return;
                }

                var wt = $w.scrollTop(),
                    wb = wt + $w.height(),
                    et = $e.offset().top,
                    eb = et + $e.height();

                return eb >= wt - th && et <= wb + th;
            });

            loaded = inview.trigger("lazyImage");
            images = images.not(loaded);
        }

        oScrollEnd.attach("scrollEnd", lazyImage);
        $w.scroll(lazyImage);
        $w.resize(lazyImage);
        $w.on("scroll.lazyImage resize.lazyImage lookup.lazyImage", lazyImage);

        lazyImage();

        return this;

    };

})(window.jQuery || window.Zepto);